import React from 'react';
import graphql from 'graphql';
import Imgix from 'react-imgix';
import { BackBannerBio } from '../components/Banners';
import { endSlash } from '../util/helperFunctions';
import Meta from '../components/Meta';
import Block from '../components/Blocks';

// This template: Staff bio pages. A headshot, optional background image, bio text.
class BioPage extends React.Component {
  state = {
    hasError: false,
    // below is intended for development, leave false
    displayError: false,
  };

  componentDidCatch(error, info) {
    /* eslint-disable no-console */
    console.log(error);
    console.log(info);
    // Display fallback UI
    this.setState({ hasError: true });
  }

  render() {
    // TODO: add proper type validation
    const { data } = this.props; // eslint-disable-line react/prop-types
    const page = data.mortyPage;
    const blocks = page.childrenMortyBlock.map(b => <Block key={b.id} block={b} />);

    if (this.state.hasError && this.state.displayError) {
      return <div>Hmm... error was caught by BioPage component.</div>;
    }

    return (
      <div className="bio-page mb3 mb4-l">
        <Meta page={page} />
        <BackBannerBio page={page} />
        <div className="flex flex-column justify-end mt3 mt4-l">
          <div className="bio-page-backdrop-wrapper">
            {page.bannerImage && (
              <Imgix
                src={endSlash(page.bannerImage.url)}
                imgixParams={{
                  'max-w': 891, // dimensions from comp * 1.5 seem about right
                  'max-h': 204,
                  'fp-x': page.bannerImageFocalPointX,
                  'fp-y': page.bannerImageFocalPointY,
                  auto: ['compress'],
                  fit: 'crop',
                  crop: 'focalpoint',
                }}
                htmlAttributes={{
                  alt: page.bannerImageAltText,
                }}
              />
            )}
          </div>
          <div className="bio-page-headshot">
            {page.abstractPhoto && (
              <Imgix
                src={endSlash(page.abstractPhoto.url)}
                imgixParams={{
                  'max-w': 204,
                  'max-h': 204,
                  'fp-x': page.bannerImageFocalPointX,
                  'fp-y': page.bannerImageFocalPointY,
                  auto: ['compress'],
                  fit: 'crop',
                  crop: 'faces',
                }}
                htmlAttributes={{
                  alt: page.abstractPhotoAltText,
                }}
              />
            )}
          </div>
        </div>
        <div>
          <h1 className="dark h-2 h-1--l tc mb0 m-t-48 mb2 mh2">{page.title}</h1>
          <div className="w-calc-64 mw-696 center">{blocks}</div>
        </div>
      </div>
    );
  }
}

export default BioPage;

export const pageQuery = graphql`
  query BioPage($id: String!) {
    mortyPage(id: { eq: $id }) {
      title
      route
      abstract
      metaTitle
      metaDescription
      bannerImage {
        url
        height
        width
      }
      bannerImageAltText
      metaKeywords
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionAltText
        attributionPhoto {
          url
        }
      }
    }
  }
`;

export const previewQuery = `
  query BioPage($id: String!) {
    mortyPage(id: { eq: $id }) {
      title
      route
      abstract
      metaTitle
      metaDescription
      bannerImage {
        url
        height
        width
      }
      bannerImageAltText
      metaKeywords
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionAltText
        attributionPhoto {
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Bio-Page.js